import PageView from '../components/collection_campaign_page/PageView';
import GetACardModal from '../components/GetACardModal/GetACardModal';

void (window.pageView = new PageView({
    el: '.Carousels',
    viewId: 'home',
    bus: window.globalEvents,
    room: window.OverDrive.currentRoom,
    featureManager: window.featureManager,
    patronSettings: window.patronSettings,
}));

$(() => {
    // Only one of these modals should show at a time. This is driven by the "library" middleware
    if (window.OverDrive.showGetACardModal) {
        new GetACardModal();
    }
});
